import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
    hideModalAction,
    showModalAction,
} from '../../redux/action/modalAction';
import {
    showExtraModalAction,
    hideExtraModalAction
} from '../../redux/action/extraModalAction';

export const useModal = () => {
// Get modal params from store using reselect
    return {
    modal: useSelector(showModalAction, shallowEqual)
    };
};

export const useModalExtra = () => {
    // Get modal params from store using reselect
    return {
    modalExtra: useSelector(showExtraModalAction, shallowEqual)
    };
};

export const useHideModal = () => {
    const dispatch = useDispatch();
    const handleOnClose = useCallback(() => {
    dispatch(hideModalAction());
    }, [dispatch]);
    return {
        handleOnClose 
    }
};

export const useHideExtraModal = () => {
    const dispatch = useDispatch();
    const handleOnCloseExtra = useCallback(() => {
    dispatch(hideExtraModalAction());
    }, [dispatch]);
    return {
        handleOnCloseExtra 
    }
};